<template>
  <div id="app">
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <snackbarcomp
          v-bind:mesaj="text1"
          v-model="snackbar"
        ></snackbarcomp>

        <v-layout row wrap>
          <v-flex xs12>
            <v-toolbar dark color="info">
              <v-btn
                icon
                dark
                :disabled="aktarimDevamEdiyor"
                @click="geriDon"
              >
                <v-icon>arrow_back</v-icon>
              </v-btn>

              <v-toolbar-title class="baslikfont">
                Ülkeleri Aktar
              </v-toolbar-title>

              <v-spacer></v-spacer>

              <v-chip
                v-if="durum.completed"
                color="success"
                text-color="white"
              >
                <v-icon left>check_circle</v-icon>
                Tamamlandı
              </v-chip>
            </v-toolbar>
          </v-flex>

          <v-flex xs12>
            <v-container fluid grid-list-lg>
              <v-layout row wrap justify-center>
                <v-flex xs12 md11 lg10>
                  <v-card class="main-card" elevation="5">

                    <!-- BAŞLIK -->
                    <v-card-title class="pa-4">
                      <v-layout row wrap align-center>
                        <v-flex xs12 sm8>
                          <div class="headline font-weight-medium">
                            Dünya Lokasyon Verilerini Aktar
                          </div>

                          <div class="grey--text text--darken-1 mt-2">
                            JSON içerisindeki ülke, bölge, şehir ve ilçe bilgileri
                            mevcut Coper veritabanına kontrollü olarak aktarılır.
                          </div>
                        </v-flex>

                        <v-flex xs12 sm4 class="text-sm-right">
                          <v-avatar size="76" color="blue lighten-5">
                            <v-icon size="46" color="info">public</v-icon>
                          </v-avatar>
                        </v-flex>
                      </v-layout>
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-card-text class="pa-4">

                      <!-- UYARI -->
                      <v-alert
                        :value="true"
                        type="warning"
                        outline
                        class="mb-4"
                      >
                        <strong>Önemli:</strong>
                        Aktarım başladıktan sonra ilerleme çubuğu
                        <strong>%100</strong> olana kadar bu sayfayı kapatmayınız.
                        İşlem tamamlandığında <strong>Onay</strong> butonu aktif olacaktır.
                      </v-alert>

                      <!-- BAŞLAMADAN ÖNCE -->
                      <v-card
                        v-if="!aktarimDevamEdiyor && !durum.completed && durum.completedCount === 0"
                        flat
                        class="start-card pa-4 mb-4"
                      >
                        <v-layout row wrap align-center>
                          <v-flex xs12 sm8>
                            <div class="title">
                              Aktarım için hazır
                            </div>
                            <div class="body-2 grey--text mt-2">
                              İşlem yalnızca aşağıdaki butona bastığınızda başlayacaktır.
                              Ülke listeleri açılırken otomatik aktarım yapılmaz.
                            </div>
                          </v-flex>

                          <v-flex xs12 sm4 class="text-sm-right mt-3 mt-sm-0">
                            <v-btn
                              color="success"
                              dark
                              large
                              :disabled="durumYukleniyor || aktarimDevamEdiyor"
                              @click="aktarimiBaslat"
                            >
                              <v-icon left>cloud_upload</v-icon>
                              Ülkeleri Aktar
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card>

                      <!-- PROGRESS -->
                      <v-card
                        v-if="aktarimDevamEdiyor || durum.completedCount > 0 || durum.completed"
                        flat
                        class="progress-card pa-4 mb-4"
                      >
                        <v-layout row wrap align-center>
                          <v-flex xs12 sm8>
                            <div class="title">
                              {{ progressBaslik }}
                            </div>

                            <div class="body-2 grey--text text--darken-1 mt-2">
                              {{ progressMesaj }}
                            </div>
                          </v-flex>

                          <v-flex xs12 sm4 class="text-sm-right">
                            <span class="display-1 font-weight-bold info--text">
                              %{{ yuzde }}
                            </span>
                          </v-flex>
                        </v-layout>

                        <v-progress-linear
                          class="mt-4"
                          :value="yuzde"
                          height="18"
                          color="info"
                          background-color="blue lighten-5"
                        ></v-progress-linear>

                        <v-layout row wrap class="mt-2">
                          <v-flex xs12 sm6>
                            <span class="caption grey--text">
                              {{ durum.completedCount | numberformat }}
                              /
                              {{ durum.total | numberformat }}
                              işlem tamamlandı
                            </span>
                          </v-flex>

                          <v-flex xs12 sm6 class="text-sm-right">
                            <span class="caption grey--text">
                              {{ sonIslenen }}
                            </span>
                          </v-flex>
                        </v-layout>

                        <v-alert
                          v-if="aktarimDevamEdiyor"
                          :value="true"
                          type="info"
                          outline
                          class="mt-4 mb-0"
                        >
                          Aktarma işlemi biraz vakit alabilir, lütfen bekleyiniz.
                          İşlem <strong>%100</strong> tamamlanana kadar bu sayfayı kapatmayınız.
                        </v-alert>

                        <v-alert
                          v-else-if="aktarimYaridaKaldi && !hataMesaji"
                          :value="true"
                          type="warning"
                          outline
                          class="mt-4 mb-0"
                        >
                          Aktarım daha önce tamamlanmadan durmuş görünüyor.
                          Tamamlanan işlemler korunmuştur.
                          <strong>Aktarıma Devam Et</strong> butonuyla kaldığınız yerden devam edebilirsiniz.
                        </v-alert>
                      </v-card>

                      <!-- HATA -->
                      <v-alert
                        v-if="hataMesaji"
                        :value="true"
                        type="error"
                        outline
                        class="mb-4"
                      >
                        {{ hataMesaji }}
                      </v-alert>

                      <!-- AKTARILAN / AKTARILAMAYAN -->
                      <v-layout row wrap>
                        <v-flex xs12 md6>
                          <v-card class="list-card" flat>
                            <v-card-title class="pb-2">
                              <v-icon color="success" class="mr-2">
                                check_circle
                              </v-icon>

                              <span class="title">
                                Aktarılan Ülkeler
                              </span>

                              <v-spacer></v-spacer>

                              <v-chip
                                small
                                color="success"
                                text-color="white"
                              >
                                {{ aktarilanUlkeler.length }}
                              </v-chip>
                            </v-card-title>

                            <v-divider></v-divider>

                            <v-card-text class="country-list">
                              <div
                                v-if="aktarilanUlkeler.length === 0"
                                class="grey--text text-xs-center pa-4"
                              >
                                Henüz aktarılmış ülke yok.
                              </div>

                              <v-list
                                v-else
                                dense
                                class="transparent"
                              >
                                <v-list-tile
                                  v-for="(item, index) in aktarilanUlkeler"
                                  :key="'ok-' + index + '-' + item"
                                >
                                  <v-list-tile-action>
                                    <v-icon color="success">
                                      check
                                    </v-icon>
                                  </v-list-tile-action>

                                  <v-list-tile-content>
                                    <v-list-tile-title>
                                      {{ item }}
                                    </v-list-tile-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </v-list>
                            </v-card-text>
                          </v-card>
                        </v-flex>

                        <v-flex xs12 md6>
                          <v-card class="list-card" flat>
                            <v-card-title class="pb-2">
                              <v-icon color="error" class="mr-2">
                                error
                              </v-icon>

                              <span class="title">
                                Aktarılamayan Ülkeler
                              </span>

                              <v-spacer></v-spacer>

                              <v-chip
                                small
                                color="error"
                                text-color="white"
                              >
                                {{ aktarilamayanUlkeler.length }}
                              </v-chip>
                            </v-card-title>

                            <v-divider></v-divider>

                            <v-card-text class="country-list">
                              <div
                                v-if="aktarilamayanUlkeler.length === 0"
                                class="grey--text text-xs-center pa-4"
                              >
                                Aktarılamayan ülke bulunmuyor.
                              </div>

                              <v-list
                                v-else
                                dense
                                class="transparent"
                              >
                                <v-list-tile
                                  v-for="(item, index) in aktarilamayanUlkeler"
                                  :key="'err-' + index"
                                >
                                  <v-list-tile-action>
                                    <v-icon color="error">
                                      close
                                    </v-icon>
                                  </v-list-tile-action>

                                  <v-list-tile-content>
                                    <v-list-tile-title>
                                      {{ item.ulke }}
                                    </v-list-tile-title>

                                    <v-list-tile-sub-title>
                                      {{ item.mesaj }}
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </v-list>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-layout>

                    </v-card-text>

                    <v-divider></v-divider>

                    <!-- ALT BUTONLAR -->
                    <v-card-actions class="pa-4">
                      <v-btn
                        flat
                        color="grey darken-1"
                        :disabled="aktarimDevamEdiyor"
                        @click="geriDon"
                      >
                        <v-icon left>arrow_back</v-icon>
                        Geri Dön
                      </v-btn>

                      <v-spacer></v-spacer>

                      <v-btn
                        v-if="hataMesaji && !durum.completed && !aktarimDevamEdiyor"
                        color="warning"
                        dark
                        @click="aktarimiTekrarDene"
                      >
                        <v-icon left>refresh</v-icon>
                        Tekrar Dene
                      </v-btn>

                      <v-btn
                        v-else-if="aktarimYaridaKaldi && !aktarimDevamEdiyor"
                        color="info"
                        dark
                        @click="aktarimaDevamEt"
                      >
                        <v-icon left>play_arrow</v-icon>
                        Aktarıma Devam Et
                      </v-btn>

                      <v-btn
                        v-if="aktarimDevamEdiyor"
                        color="info"
                        dark
                        disabled
                      >
                        <v-icon left>hourglass_empty</v-icon>
                        Aktarım Devam Ediyor
                      </v-btn>

                      <v-btn
                        color="success"
                        dark
                        large
                        :disabled="aktarimDevamEdiyor || !durum.completed || yuzde < 100"
                        @click="onayla"
                      >
                        <v-icon left>check_circle</v-icon>
                        Onay
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import tool from "../tools";

export default {
  name: "coper-tanitimlar-ulkeaktar",

  components: {
    snackbarcomp,
  },

  data() {
    return {
      text1: null,
      snackbar: false,

      durumYukleniyor: false,
      aktarimDevamEdiyor: false,
      hataMesaji: null,
      sonIslenen: "",

      // Her istekte az sayıda aktarım yapıyoruz.
      // Bu değer küçük tutulduğu için yüzde ekranda düzenli ilerler
      // ve tek isteğin timeout olması engellenir.
      stepSize: 1,

      aktarilanUlkeler: [],
      aktarilamayanUlkeler: [],

      durum: {
        total: 0,
        completedCount: 0,
        percent: 0,
        completed: false,
        currentCountry: "",
        currentRegion: "",
        message: "",
      },
    };
  },

  computed: {
    aktarimYaridaKaldi() {
      return (
        !this.aktarimDevamEdiyor &&
        !this.durum.completed &&
        this.durum.completedCount > 0 &&
        this.yuzde > 0 &&
        this.yuzde < 100
      );
    },

    yuzde() {
      var value = Number(this.durum.percent || 0);

      if (value < 0) {
        value = 0;
      }

      if (value > 100) {
        value = 100;
      }

      return Math.floor(value);
    },

    progressBaslik() {
      if (this.durum.completed && this.yuzde >= 100) {
        return "Aktarım tamamlandı";
      }

      if (this.aktarimDevamEdiyor) {
        return "Ülkeler aktarılıyor...";
      }

      if (this.hataMesaji) {
        return "Aktarım durduruldu";
      }

      if (this.aktarimYaridaKaldi) {
        return "Aktarım kaldığı yerden devam etmeye hazır";
      }

      return "Aktarım bekliyor";
    },

    progressMesaj() {
      if (this.durum.completed && this.yuzde >= 100) {
        return "Tüm aktarım adımları tamamlandı. Onay butonunu kullanabilirsiniz.";
      }

      if (this.aktarimDevamEdiyor) {
        if (this.durum.currentCountry) {
          return (
            this.durum.currentCountry +
            " aktarılıyor. Aktarma işlemi biraz vakit alabilir, lütfen bekleyiniz."
          );
        }

        return "Aktarma işlemi biraz vakit alabilir, lütfen bekleyiniz.";
      }

      if (this.hataMesaji) {
        return "Aktarıma kaldığı yerden devam etmek için Tekrar Dene butonunu kullanabilirsiniz.";
      }

      if (this.aktarimYaridaKaldi) {
        return "Daha önce tamamlanan işlemler korunmuştur. Aktarıma kaldığınız yerden devam etmek için Aktarıma Devam Et butonuna basınız.";
      }

      return "Aktarımı başlatmak için Ülkeleri Aktar butonuna basınız.";
    },
  },

  filters: {
    numberformat(value) {
      if (value === null || value === undefined) {
        return "0";
      }

      try {
        return Number(value).toLocaleString("tr-TR");
      } catch (e) {
        return value;
      }
    },
  },

  mounted() {
    // Burada pageScreenAuth KULLANMIYORUZ.
    //
    // Sebep:
    // Bu yeni route mevcut yetki tanımlarında henüz kayıtlı olmayabileceği için
    // pageScreenAuth yeni sayfayı yetkisiz görüp kullanıcıyı başka sayfaya
    // yönlendirebiliyordu.
    //
    // Route zaten requiresAuth:true olduğu için login kontrolü router tarafında yapılır.
    this.durumGetir();
  },

  methods: {
    durumGetir() {
      this.durumYukleniyor = true;
      this.hataMesaji = null;

      tool.api_post(this, "Coper/GlobalLocationImportInfo", {}).then(
        (response) => {
          this.durumYukleniyor = false;

          if (
            response &&
            response.body &&
            response.body.Status === true
          ) {
            this.durumAta(response.body.data);
          } else {
            this.hataMesaji =
              response &&
              response.body &&
              response.body.Message
                ? response.body.Message
                : "Aktarım durumu alınamadı.";
          }
        },
        (response) => {
          this.durumYukleniyor = false;
          this.hataMesaji = this.apiHataMesaji(response);
        }
      );
    },

    aktarimiBaslat() {
      if (this.aktarimDevamEdiyor || this.durum.completed) {
        return;
      }

      this.hataMesaji = null;
      this.aktarimDevamEdiyor = true;

      this.sonrakiParcayiAktar();
    },

    sonrakiParcayiAktar() {
      if (!this.aktarimDevamEdiyor) {
        return;
      }

      if (this.durum.completed || this.yuzde >= 100) {
        this.aktarimDevamEdiyor = false;
        this.durum.completed = true;
        this.durum.percent = 100;

        this.text1 = "Ülke aktarımı başarıyla tamamlandı.";
        this.snackbar = true;
        return;
      }

      var params = {
        StepSize: this.stepSize,
      };

      tool.api_post(this, "Coper/GlobalLocationImportStep", params).then(
        (response) => {
          if (
            response &&
            response.body &&
            response.body.Status === true
          ) {
            this.durumAta(response.body.data);

            if (this.durum.currentCountry) {
              this.sonIslenen =
                this.durum.currentCountry +
                (this.durum.currentRegion
                  ? " / " + this.durum.currentRegion
                  : "");

              this.aktarilanUlkeEkle(this.durum.currentCountry);
            }

            if (this.durum.completed || this.yuzde >= 100) {
              this.durum.completed = true;
              this.durum.percent = 100;
              this.aktarimDevamEdiyor = false;

              this.text1 =
                "Aktarım %100 tamamlandı. Onay butonu aktif edildi.";
              this.snackbar = true;
              return;
            }

            // UI'nin %1, %2, %3 ... şeklinde ilerlemeyi
            // gözle görülür biçimde çizmesi için küçük bekleme bırakıyoruz.
            window.setTimeout(() => {
              this.sonrakiParcayiAktar();
            }, 120);
          } else {
            this.aktarimHatasi(
              response &&
              response.body &&
              response.body.Message
                ? response.body.Message
                : "Aktarım sırasında bilinmeyen bir hata oluştu."
            );
          }
        },
        (response) => {
          this.aktarimHatasi(
            this.apiHataMesaji(response)
          );
        }
      );
    },

    aktarimHatasi(message) {
      this.aktarimDevamEdiyor = false;
      this.hataMesaji = message;

      var ulke =
        this.hataMesajindanUlkeBul(message) ||
        this.durum.currentCountry ||
        "Bilinmeyen ülke";

      this.aktarilamayanUlkeEkle(
        ulke,
        message
      );
    },

    aktarimiTekrarDene() {
      if (this.durum.completed || this.aktarimDevamEdiyor) {
        return;
      }

      this.hataMesaji = null;
      this.aktarimDevamEdiyor = true;
      this.sonrakiParcayiAktar();
    },

    aktarimaDevamEt() {
      if (
        this.aktarimDevamEdiyor ||
        this.durum.completed ||
        !this.aktarimYaridaKaldi
      ) {
        return;
      }

      this.hataMesaji = null;
      this.aktarimDevamEdiyor = true;
      this.sonrakiParcayiAktar();
    },

    aktarilanUlkeEkle(ulke) {
      if (!ulke) {
        return;
      }

      if (this.aktarilanUlkeler.indexOf(ulke) === -1) {
        this.aktarilanUlkeler.unshift(ulke);
      }
    },

    aktarilamayanUlkeEkle(ulke, mesaj) {
      var exists = this.aktarilamayanUlkeler.some((item) => {
        return item.ulke === ulke;
      });

      if (!exists) {
        this.aktarilamayanUlkeler.unshift({
          ulke: ulke,
          mesaj: mesaj,
        });
      }
    },

    hataMesajindanUlkeBul(message) {
      if (!message) {
        return "";
      }

      // Backend hata mesajı:
      // Aktarım hatası [TÜRKİYE / MARMARA]: ...
      var match = message.match(/\[([^\]\/]+)(?:\/[^\]]+)?\]/);

      if (match && match.length > 1) {
        return match[1].trim();
      }

      return "";
    },

    durumAta(data) {
      if (!data) {
        return;
      }

      this.durum.total = Number(data.Total || 0);
      this.durum.completedCount = Number(data.CompletedCount || 0);
      this.durum.percent = Number(data.Percent || 0);
      this.durum.completed = data.Completed === true;
      this.durum.currentCountry = data.CurrentCountry || "";
      this.durum.currentRegion = data.CurrentRegion || "";
      this.durum.message = data.Message || "";

      if (this.durum.completed) {
        this.durum.percent = 100;
      }
    },

    onayla() {
      if (!this.durum.completed || this.yuzde < 100) {
        return;
      }

      this.text1 = "Aktarım tamamlandı.";
      this.snackbar = true;

      window.setTimeout(() => {
        this.$router.push({
          name: "coper-tanitimlar-parametrelist",
        });
      }, 500);
    },

    geriDon() {
      if (this.aktarimDevamEdiyor) {
        return;
      }

      this.$router.push({
        name: "coper-tanitimlar-parametrelist",
      });
    },

    apiHataMesaji(response) {
      if (!response) {
        return "Sunucuyla bağlantı kurulamadı.";
      }

      if (response.body) {
        if (response.body.Message) {
          return response.body.Message;
        }

        if (response.body.ExceptionMessage) {
          return response.body.ExceptionMessage;
        }

        if (typeof response.body === "string") {
          return response.body;
        }
      }

      return "Aktarım sırasında sunucu hatası oluştu.";
    },
  },
};
</script>

<style scoped>
.main-card {
  border-radius: 16px;
  overflow: hidden;
}

.start-card {
  border: 1px solid #dce8df;
  border-radius: 12px;
  background: #fbfffc;
}

.progress-card {
  border: 1px solid #d9e8f7;
  border-radius: 12px;
  background: #f8fbff;
}

.list-card {
  border: 1px solid #e5e8ed;
  border-radius: 12px;
  min-height: 330px;
}

.country-list {
  max-height: 350px;
  overflow-y: auto;
}
</style>
